// HOOKS
import { useLazyQuery } from "@apollo/client";
import useQuery from "../other/useQuery.other.hook";
import { useState, useEffect } from "react";
import useAbortController from "../other/useAbortController.other.hook";
// GRAPHQL
import { GET_SHIPMENTS } from "../../graphql/queries/shipments/shipment.queries";
// UTILS
import convertToyyyyMMddThhmm from "../../utils/conversions/dates/yyyyMMddThhmm.date.conversion.util";

const DEFAULT_QUERY = {
  search: "",
  page: 1,
  limit: 10,
  sort: "-updated_at",
};

const useGetManyShipments = () => {
  const [shipments, setShipments] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [shipmentInput, setShipmentInput] = useState({});
  const [getShipmentQuery, { loading, error, data }] = useLazyQuery(
    GET_SHIPMENTS,
    { fetchPolicy: "no-cache" }
  );

  // Using the abort controller hook
  const { createAbortController, signal } = useAbortController();

  const {
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
  } = useQuery({ defaultQuery: DEFAULT_QUERY });

  const getShipments = async () => {
    const controller = createAbortController(); // Create a new controller for each request

    try {
      const res = await getShipmentQuery({
        variables: { query, shipment: shipmentInput },
        context: {
          fetchOptions: {
            signal: controller.signal, // Pass the signal from the controller
          },
        },
      });
      if (res?.data?.shipments?.shipments)
        setShipments(
          res.data.shipments.shipments.map((shipment) => ({
            ...shipment,
            created_at: convertToyyyyMMddThhmm(shipment?.created_at),
            updated_at: convertToyyyyMMddThhmm(shipment?.updated_at),
          }))
        );
      if (res?.data?.shipments?.metaData)
        setMetaData(res.data.shipments.metaData);
    } catch (err) {
      if (err.name === "AbortError") {
        console.log("Request was aborted");
      } else {
        console.error(`Error getting shipments: ${err}`);
        alert(`Error getting shipments: ${err}`);
      }
    }
  };

  useEffect(() => {
    getShipments();
  }, [query, shipmentInput]);

  return {
    getShipments,
    shipments,
    setShipments,
    metaData,
    shipmentInput,
    setShipmentInput,
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    loading,
    error,
  };
};

export default useGetManyShipments;
